export default __webpack_public_path__ + "static/Quickinstallation_IN-6001_06-cbcdcbcb01331569e07589c637f916a8.webp";